const defaultTranslations = {
  account_portal: {
    title: 'Login or create a Fit Club account',
    cta_text: 'Tell us more about you',
    brand_button: {
      text: 'Sign up',
      link: '/account/register'
    },
    sign_up_list: {
      item_1_icon: 'bag',
      item_1: 'Receive 10% cashback for your next order',
      item_2_icon: 'Birthday',
      item_2: 'Each child will enjoy a $10 birthday reward',
      item_3_icon: 'assign-shoe',
      item_3: 'Earn $2 for each shoe assigned to a child'
    },
    account_terms_conditions_html: "<p>*By registering, I agree to be a VIP in Shoes & Sox's VIP program & agree to Shoes & Sox's T&C's and how my data may be collected & used as set out in Shoes & Sox's <a target='_blank' href='/pages/privacy-policy'> privacy policy.</a></p>",
    sign_up_success_title: 'Check Your inbox',
    sign_up_success_description: "We've just sent you a message to access your secure profile. You can also show this barcode to the Shoes & Sox Expert Shoe Crew so they can quickly find your details.",
    sign_up_mobile_code_description: "We've just sent a code to your mobile number. Please check your messages and enter the code to activate your account and access your profile."
  }
}

export const accountTranslations = window.globals?.translations || defaultTranslations
